<template>
  <div>
    <!-- ─── CARTÕES ─── -->
    <b-row class="pb-2">
      <b-col xl="4">
        <h1 class="db-section-title pt-3">Cartões</h1>
      </b-col>
    </b-row>
    <b-row class="db-kpi-row-wrap">
      <b-col xl="4">
        <div class="db-kpi-card">
          <h3 class="db-kpi-label">Cartões Emitidos</h3>
          <h2 class="db-kpi-val">{{ dados.cartoes_emitidos }}</h2>
          <p
            :class="
              classeDiferenca(
                dados.cartoes_emitidos,
                dados.cartoes_emitidos_prev,
              )
            "
            class="db-kpi-delta"
          >
            {{ diferenca(dados.cartoes_emitidos, dados.cartoes_emitidos_prev) }}
          </p>
        </div>
      </b-col>
      <b-col xl="4">
        <div class="db-kpi-card">
          <h3 class="db-kpi-label">Visitas Únicas</h3>
          <h2 class="db-kpi-val">{{ dados.clientes_ativos }}</h2>
          <p
            :class="
              classeDiferenca(dados.clientes_ativos, dados.clientes_ativos_prev)
            "
            class="db-kpi-delta"
          >
            {{ diferenca(dados.clientes_ativos, dados.clientes_ativos_prev) }}
          </p>
        </div>
      </b-col>
      <b-col xl="4">
        <div class="db-kpi-card">
          <h3 class="db-kpi-label">Visitas</h3>
          <h2 class="db-kpi-val">{{ dados.visitas_total }}</h2>
          <p
            :class="
              classeDiferenca(dados.visitas_total, dados.visitas_total_prev)
            "
            class="db-kpi-delta"
          >
            {{ diferenca(dados.visitas_total, dados.visitas_total_prev) }}
          </p>
        </div>
      </b-col>
    </b-row>

    <!-- ─── REFEIÇÕES ─── -->
    <b-row class="pb-2">
      <b-col xl="4">
        <h1 class="db-section-title">Refeições</h1>
      </b-col>
    </b-row>
    <b-row class="db-kpi-row-wrap">
      <b-col xl="4">
        <div class="db-kpi-card db-kpi-card--accent">
          <h3 class="db-kpi-label">Frequência Média</h3>
          <h2 class="db-kpi-val db-kpi-val--orange">{{ mediaVisitas }}</h2>
          <p
            :class="classeDiferenca(mediaVisitas, mediaVisitasPrev)"
            class="db-kpi-delta"
          >
            {{ diferenca(mediaVisitas, mediaVisitasPrev) }}
          </p>
        </div>
      </b-col>
      <b-col xl="4">
        <div class="db-kpi-card db-kpi-card--accent">
          <h3 class="db-kpi-label">Ticket Médio</h3>
          <h2 class="db-kpi-val db-kpi-val--orange">
            {{
              dados.ticket_medio
                ? formatarEuro(dados.ticket_medio.toFixed(2))
                : "0 €"
            }}
          </h2>
          <p
            :class="
              classeDiferenca(dados.ticket_medio, dados.ticket_medio_prev)
            "
            class="db-kpi-delta"
          >
            {{ diferenca(dados.ticket_medio, dados.ticket_medio_prev, "euro") }}
          </p>
        </div>
      </b-col>
      <b-col xl="4">
        <div class="db-kpi-card db-kpi-card--accent">
          <h3 class="db-kpi-label">Faturação Total</h3>
          <h2 class="db-kpi-val db-kpi-val--orange">
            {{ formatarEuro(dados.faturacao_total) }}
          </h2>
          <p
            :class="
              classeDiferenca(dados.faturacao_total, dados.faturacao_total_prev)
            "
            class="db-kpi-delta"
          >
            {{
              diferenca(
                dados.faturacao_total,
                dados.faturacao_total_prev,
                "euro",
              )
            }}
          </p>
        </div>
      </b-col>
    </b-row>

    <!-- ─── CLIENTES ─── -->
    <b-row class="pb-2">
      <b-col xl="4">
        <h1 class="db-section-title">Clientes</h1>
      </b-col>
    </b-row>
    <b-row class="db-kpi-row-wrap">
      <b-col xl="4">
        <div class="db-kpi-card db-kpi-card--soft">
          <div class="pb-2">
            <h3 class="db-kpi-label">Clientes Assíduos</h3>
            <span class="db-kpi-hint">
              Visitou pelo menos {{ dados.limiteAssiduoVisitas }} vezes em
              {{ dados.limiteAssiduoDias }} dias
            </span>
          </div>
          <h2 class="db-kpi-val">{{ dados.clientes_assiduos }}</h2>
          <p class="db-kpi-action" @click="$emit('ver-clientes', 'assiduo')">
            Ver Clientes →
          </p>
        </div>
      </b-col>
      <b-col xl="4">
        <div class="db-kpi-card db-kpi-card--soft">
          <div class="pb-2">
            <h3 class="db-kpi-label">Clientes Frequentes</h3>
            <span class="db-kpi-hint">
              Visitou pelo menos {{ dados.limiteFrequenteVisitas }} vezes em
              {{ dados.limiteFrequenteDias }} dias
            </span>
          </div>
          <h2 class="db-kpi-val">{{ dados.clientes_frequentes }}</h2>
          <p class="db-kpi-action" @click="$emit('ver-clientes', 'frequente')">
            Ver Clientes →
          </p>
        </div>
      </b-col>
      <b-col xl="4">
        <div class="db-kpi-card db-kpi-card--soft">
          <div class="pb-2">
            <h3 class="db-kpi-label">Clientes Ocasionais</h3>
            <span class="db-kpi-hint">
              Visitou pelo menos {{ dados.limiteOcasionalVisitas }} vezes em
              {{ dados.limiteOcasionalDias }} dias
            </span>
          </div>
          <h2 class="db-kpi-val">{{ dados.clientes_ocasionais }}</h2>
          <p class="db-kpi-action" @click="$emit('ver-clientes', 'ocasional')">
            Ver Clientes →
          </p>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    name: "DashboardKpis",
    props: {
      dados: { type: Object, default: () => ({}) },
      mediaVisitas: { type: [Number, String], default: 0 },
      mediaVisitasPrev: { type: [Number, String], default: 0 },
    },
    methods: {
      diferenca(actual, previous, tipo = "numero") {
        const a = Number(actual) || 0;
        const p = Number(previous) || 0;
        const diff = a - p;
        const sinal = diff > 0 ? "+" : diff < 0 ? "-" : "";
        if (tipo === "euro") return sinal + this.formatarEuro(Math.abs(diff));
        return sinal + new Intl.NumberFormat("pt-PT").format(Math.abs(diff));
      },
      formatarEuro(valor) {
        return new Intl.NumberFormat("fr-FR", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(valor);
      },
      classeDiferenca(a, b) {
        if (Number(a) > Number(b)) return "positive";
        if (Number(a) < Number(b)) return "negative";
        return "";
      },
    },
  };
</script>
